<script setup lang="ts">
const { muted = true, autoplay = true } = defineProps<{
  muted?: boolean;
  autoplay?: boolean;
  disableControls?: boolean;
}>();

const videoPlayer = useTemplateRef("videoPlayer");
defineExpose({ videoEl: videoPlayer });
</script>

<template>
  <video
    ref="videoPlayer"
    v-bind="$attrs"
    :autoplay="autoplay"
    class="video-player"
    :muted="muted"
    webkit-playsinline="true"
    playsinline="true"
    :loop="true"
    :controls="disableControls ? false : !muted && autoplay"
  >
    <slot />
  </video>
</template>
